<template>
  <div>
    <detail :prop="counterpartyRole" :value="tx.counterparty" :copiable="true"/>
    <detail :prop="i18n.lbl_amount()" :value="`${i18n.c(tx.amount)} ${formatTokenDisplay(tx.asset)}`"/>
    <detail :prop="i18n.lbl_transfer_fee()" :value="`${transferFee} ${formatTokenDisplay(tx.asset)}`"/>
    <detail :prop="i18n.lbl_date()" :value="tx.date"/>
    <detail :prop="i18n.lbl_subject()" :value="`${tx.subject}`" class="subject-detail"/>
  </div>
</template>

<script>
  import { add, subtract } from '@utils/math.util'
  import DetailsMixin from './details.mixin'

  export default {
    name: 'transfer-details',
    mixins: [DetailsMixin],
    computed: {
      counterpartyRole () {
        return this.tx.direction === 'out' ? this.i18n.lbl_receiver() : this.i18n.lbl_sender()
      },
      senderPaid () {
        return this.tx.fee === 'Sender paid'
      },
      transferFee () {
        if (this.senderPaid) return this.tx.fee
        return this.i18n.c(this.tx.fee)
      },
      totalPaid () {
        return add(this.tx.amount, this.transferFee)
      },
      totalReceived () {
        if (this.senderPaid) return this.tx.amount
        return subtract(this.tx.amount, this.transferFee)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .subject-detail {
    text-align: right;
    margin-top: 8px
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/history/index/components/Details.Transfer.vue